module.exports = __webpack_public_path__ + "img/G@2x.df476f4a.jpg";